<template>
  <v-layout
    fill-height
    fluid
    column
  >
    <v-layout
      row
      align-center
      shrink
      style="cursor:pointer;" @click="$emit('update:quality', false)"
    >
      <v-flex xs2><v-icon dark>keyboard_arrow_left</v-icon></v-flex>
      <v-flex xs10>Quality</v-flex>
    </v-layout>
    <v-divider
      color="white"
    ></v-divider>
    <v-layout
      pa-1
      fill-height
      fluid
      column
    >
      <v-list
        dark
        dense
        class="my-list pa-0"
      >
        <v-list-tile
          v-for="(value, name) in qualities"
          :key="name"
          @click="select(name, value)"
          v-if="value"
          :color="selectedQuality === name ? 'red' : 'white'"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="name"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-layout>
  </v-layout>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */
export default {
  name: 'QualitySettings',
  data() {
    return {
      qualities: {
        auto: this.$store.state.project['dash'],
        '240p': this.$store.state.project['240p'],
        '360p': this.$store.state.project['360p'],
        '480p': this.$store.state.project['480p'],
        '720p': this.$store.state.project['720p'],
        '1080p': this.$store.state.project['1080p'],
        '1440p': this.$store.state.project['1440p'],
        '2160p': this.$store.state.project['2160p'],
        'low': this.$store.state.project['low'],
        'medium': this.$store.state.project['medium'],
        'high': this.$store.state.project['high'],
        'original file': this.$store.state.project['file'],
      },
    };
  },
  computed: {
    selectedQuality() {
      return this.$store.state.selectedQuality;
    },
  },
  methods: {
    select(name, value) {
      if (value.includes('.mov')) {
        this.$eventHub.$emit('reader-error', {
          title: 'Format not supported',
          text: 'Reader doesn\'t support MOV video format',
        });
        return;
      }
      this.$store.commit('selectedQuality', name);
      if (name === 'auto') {
        this.$player.setAutoQuality();
      } else {
        this.$player.changeVideoSource(value);
      }
    },
  },
};
</script>

<style>
.my-list {
  background-color: rgba(0,0,0,0) !important;
}
.my-list .v-list__tile {
    height: 25px !important;
}
</style>
